import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgWorkspaceSettingsUrl from '@/assets/misc/img_workspace-settings.svg'
import PortalOverviewProfileIllustration from '@/components/SpotIllustration/PortalOverviewProfileIllustration'

export interface OpenItemsDialogProps {
  showing: boolean
  corporateMode: boolean
  isReportPending: boolean
  onClose: () => unknown
  onReport: () => unknown
}

export function OpenItemsDialog({
  showing,
  corporateMode,
  isReportPending,
  onClose,
  onReport,
}: OpenItemsDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isReportPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgWorkspaceSettingsUrl}
              illustration={byDesign(
                undefined,
                PortalOverviewProfileIllustration,
              )}
            />
          )}
          <ModalSheetContentTitle>
            Are you sure you want to report open items?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Reporting open items will notify the client that certain documents
            are missing. Please ensure you have prepared a list of missing items
            to provide to the client.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isReportPending}
          />
          <Button
            label="Report Open Items"
            type="submit"
            isPending={isReportPending}
            isDisabled={isReportPending}
            onPress={onReport}
            variant="primary"
            testId="job-progression-set-open-items-dialog-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
